// extracted by mini-css-extract-plugin
export default {"body":"body-EgU5b","footer":"footer-jdd0K","actions":"actions-iMPnB","active":"active-ciMAa"};